<div class="content-wrap">
  <div class="row">
    <h2 class="title">
      {{ "account.title" | translate }}
    </h2>
  </div>
  <div *ngIf="currentMerchant$ | async as merchant" class="content">
    <app-account-card class="card section" [merchant]="merchant"></app-account-card>
    <app-devices class="devices section"></app-devices>
    <app-account-change-email class="email section"></app-account-change-email>
    <app-account-change-pin class="pin section"></app-account-change-pin>
  </div>
  &nbsp;
</div>
